import React, { Fragment, useState } from 'react';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import IconSun from '../../components/Icon/IconServer';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import DashboardDataModalWrapper from './DashboardDataModalWrapper';
function DashboardTabComp({ tabs, activeTab, onTabChange, data }) {
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility state

  // Function to toggle modal visibility
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <div className="mt-5" id="pills_with_icon">
      <div className="mb-3">
        <TabGroup selectedIndex={activeTab} onChange={onTabChange}>
          <TabList className="mt-3 flex flex-wrap border-b border-white-light dark:border-[#191e3a]">
            {tabs.map((tab, index) => (
              <Tab as={Fragment} key={index}>
                {({ selected }) => (
                  <button
                    className={`${
                      selected
                        ? '!border-white-light !border-b-white text-secondary !outline-none dark:!border-[#191e3a] dark:!border-b-black'
                        : ''
                    } dark:border-[#191e3a]' -mb-[1px] flex items-center border border-transparent p-3.5 py-2 hover:text-secondary`}
                  >
                    {tab.icon && <tab.icon className="mb-1 mr-2" />}
                    {tab.label}
                  </button>
                )}
              </Tab>
            ))}
          </TabList>
          <TabPanels className="flex-1 border border-t-0 overflow-auto border-white-light p-4 text-sm dark:border-[#191e3a]">
            {tabs.map((tab, index) => (
              <TabPanel key={index}>
                <div>
                  <h1 className="mb-2 text-base font-semibold">{tab.header}</h1>
                  {/* <Tippy content="Data">
                    <button
                      type="button"
                      data-dismissable="true"
                      className="btn btn-secondary w-10 h-10 p-0 rounded-full"
                      onClick={toggleModal}
                      disabled={!tab.data || tab.data.length === 0} // Disable if no data
                    >
                      <IconSun />
                    </button>
                  </Tippy> */}
                  {tab.component}
                </div>
              </TabPanel>
            ))}
          </TabPanels>
        </TabGroup>
        {/* Modal Rendering */}
        {isModalOpen && (
          <DashboardDataModalWrapper
            isOpen={isModalOpen}
            onClose={toggleModal} // Pass function to close modal
            dashboardTableData={data}
          />
        )}
      </div>
    </div>
  );
}

export default DashboardTabComp;
